<!-- Footer -->
<footer class="sticky-footer bg-white">
    <div class="container my-auto">
        <div class="copyright text-center my-auto">
            <span>Copyright &copy; RadarQR </span>
        </div>
    </div>
</footer>
<!-- End of Footer -->